import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Mutation } from 'react-apollo';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import { CREATE_PRODUCT } from '../../libs/Mutations';
import theme from '../../theme';

const styles = {
    root: { flexGrow: 1 },
    paper: {
        padding: theme.spacing(3),
        margin: theme.spacing(2),
        background: theme.palette.common.white,
    },
    sectionTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
        textTransform: 'uppercase',
        fontSize: 13,
        color: theme.palette.grey[700],
    },
};

const COMPONENT_TYPES = [
    { value: '', label: '(none)' },
    { value: 'MODULAR', label: 'Modular' },
    { value: 'MASTER', label: 'Master' },
    { value: 'STANDALONE', label: 'Standalone' },
    { value: 'INVERTER_CONTROLLER', label: 'Inverter controller' },
];

class AddProductForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            model: '',
            modelNameType: 'CEC',
            formError: null,
            productType: 'BATTERY',
            batteryComponentType: '',
            isSmart: false,
            nominalStorageKwh: '',
            nominalUsableKwh: '',
            nominalVoltage: '',
            nominalMaxPowerKw: '',
            wattage: '',
            firetested: '',
            approvedDate: null,
            expiryDate: null,
        };
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    };

    handleSelect = (name) => (e) => this.setState({ [name]: e.target.value });

    buildProductInput = () => {
        const s = this.state;
        const num = (v) => {
            if (v === '' || v == null) return null;
            const n = parseFloat(v);
            return Number.isFinite(n) ? n : null;
        };
        const intv = (v) => {
            if (v === '' || v == null) return null;
            const n = parseInt(v, 10);
            return Number.isFinite(n) ? n : null;
        };
        return {
            brand: null,
            model: s.model || null,
            modelNameType: s.modelNameType || 'CEC',
            productType: s.productType || 'BATTERY',
            batteryComponentType: s.batteryComponentType || null,
            isSmart: s.isSmart,
            nominalStorageKwh: num(s.nominalStorageKwh),
            nominalUsableKwh: num(s.nominalUsableKwh),
            nominalVoltage: s.nominalVoltage || null,
            nominalMaxPowerKw: num(s.nominalMaxPowerKw),
            wattage: intv(s.wattage),
            firetested: s.firetested || null,
            approvedDate: s.approvedDate ? moment(s.approvedDate).format('YYYY-MM-DD') : null,
            expirydate: s.expiryDate ? moment(s.expiryDate).format('YYYY-MM-DD') : null,
        };
    };

    handleSubmit = (createProduct) => {
        const { model } = this.state;
        if (!String(model || '').trim()) {
            this.setState({ formError: 'Enter a model name.' });
            return;
        }
        this.setState({ formError: null });
        createProduct({ variables: { product: this.buildProductInput() } })
            .then(() => {
                this.props.history.push('/dashboard/');
            })
            .catch(() => {});
    };

    render() {
        const { classes } = this.props;
        const s = this.state;

        return (
            <Fragment>
                <Helmet>
                    <title>Add product model — SPV</title>
                </Helmet>
                <Mutation mutation={CREATE_PRODUCT}>
                    {(createProduct, { loading, error }) => (
                        <ValidatorForm
                            className={classes.root}
                            onSubmit={() => this.handleSubmit(createProduct)}
                            onError={(errs) => console.warn(errs)}
                        >
                            <Paper className={classes.paper} elevation={0}>
                                <Typography variant="h6" gutterBottom>
                                    Add product (model definition)
                                </Typography>
                                <Typography variant="body2" color="textSecondary" paragraph>
                                    Create a product record manually. Enter a <strong>model name</strong> and whether it is{' '}
                                    <strong>CEC</strong> or <strong>Internal</strong>.
                                </Typography>

                                <Typography className={classes.sectionTitle}>Product identity</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextValidator
                                            name="model"
                                            label="Model name"
                                            value={s.model}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel>Type</InputLabel>
                                            <Select
                                                name="modelNameType"
                                                value={s.modelNameType}
                                                onChange={this.handleSelect('modelNameType')}
                                                label="Type"
                                            >
                                                <MenuItem value="CEC">CEC</MenuItem>
                                                <MenuItem value="INTERNAL">Internal</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel>Product type</InputLabel>
                                            <Select
                                                name="productType"
                                                value={s.productType}
                                                onChange={this.handleSelect('productType')}
                                                label="Product type"
                                            >
                                                <MenuItem value="BATTERY">BATTERY</MenuItem>
                                                <MenuItem value="INVERTER">INVERTER</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel>Battery component type</InputLabel>
                                            <Select
                                                value={s.batteryComponentType}
                                                onChange={this.handleSelect('batteryComponentType')}
                                                label="Battery component type"
                                            >
                                                {COMPONENT_TYPES.map((o) => (
                                                    <MenuItem key={o.value || 'empty'} value={o.value}>
                                                        {o.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="isSmart"
                                                    checked={s.isSmart}
                                                    onChange={this.handleChange}
                                                    color="primary"
                                                />
                                            }
                                            label="Is smart"
                                        />
                                    </Grid>
                                </Grid>

                                <Typography className={classes.sectionTitle}>Capacity / electrical</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            name="nominalStorageKwh"
                                            label="Nominal storage (kWh)"
                                            value={s.nominalStorageKwh}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            name="nominalUsableKwh"
                                            label="Nominal usable (kWh)"
                                            value={s.nominalUsableKwh}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            name="nominalVoltage"
                                            label="Nominal voltage"
                                            value={s.nominalVoltage}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            name="nominalMaxPowerKw"
                                            label="Nominal max power (kW)"
                                            value={s.nominalMaxPowerKw}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            name="wattage"
                                            label="Wattage (W)"
                                            value={s.wattage}
                                            onChange={this.handleChange}
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>

                                <Typography className={classes.sectionTitle}>CEC / dates (optional)</Typography>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <KeyboardDatePicker
                                                label="Approved date"
                                                value={s.approvedDate}
                                                onChange={(d) => this.setState({ approvedDate: d })}
                                                format="DD/MM/YYYY"
                                                fullWidth
                                                inputVariant="outlined"
                                                clearable
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <KeyboardDatePicker
                                                label="Expiry date"
                                                value={s.expiryDate}
                                                onChange={(d) => this.setState({ expiryDate: d })}
                                                format="DD/MM/YYYY"
                                                fullWidth
                                                inputVariant="outlined"
                                                clearable
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextValidator
                                                name="firetested"
                                                label="Fire tested"
                                                value={s.firetested}
                                                onChange={this.handleChange}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </MuiPickersUtilsProvider>

                                {s.formError && (
                                    <Typography color="error" style={{ marginTop: 16 }}>
                                        {s.formError}
                                    </Typography>
                                )}
                                {error && (
                                    <Typography color="error" style={{ marginTop: 16 }}>
                                        {error.graphQLErrors && error.graphQLErrors.length
                                            ? error.graphQLErrors.map((e) => e.message).join(' ')
                                            : error.message}
                                    </Typography>
                                )}

                                <Grid container spacing={2} style={{ marginTop: 24 }}>
                                    <Grid item>
                                        <Button type="submit" variant="contained" color="primary" disabled={loading}>
                                            {loading ? 'Saving…' : 'Save product'}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button component={Link} to="/dashboard/" variant="outlined">
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </ValidatorForm>
                    )}
                </Mutation>
            </Fragment>
        );
    }
}

export default withStyles(styles)(withRouter(AddProductForm));
